import { trackPromise } from 'react-promise-tracker';
import { create } from 'zustand';
import { getNotificationStyle } from '../common/notification';
import { IFileUpload, IFileUploads, IFilter } from '../model/CommonModel';
import {
    FileUploadRequest,
    IAddHoldAtTerminalRequest,
    IBillTypeUpdate,
    IBulkHoldManifestRequest,
    IBulkInvoiceRequest,
    IChangeDeliveryDate, IClearCity,
    IDriverRequest, IFleetManPower, IManifestDetail,
    IManifestationRequest, INorDelivery, IOperation, IOperationState, IPieceBarcodeRequest, IPodResponse, IUpdateCodRequest, IUpdateManifest,
    IValidAgreementDetailRequest,
    IVolumetric, InitialState,
    ManifestQuotationExtraCharges
} from '../model/OperationModel';
import { findValue } from './../components/OperationComponent/Operation/OperationDetail/Manifest/hooks/SaveHook';
import { IQuotationPriceDetail, IQuotationPriceDetailList, QUOTATION_KEY, QUOTATION_LABEL } from './../model/EnquiryModal';

import { IQuotation } from '../model/EnquiryModal';
import { CancelBookingByIdService } from '../services/booking-service';
import { UploadFileService } from '../services/customer-service';
import {
    AddHoldAtTerminalService,
    AssignPodService,
    BulkInvoiceService,
    BulkHoldManifestService,
    ChangeDeliveryDateService,
    ClearOdaCityService,
    DeleteDeliveryDateService,
    DownloadBulkDeliveryService,
    DownloadBulkPickUpService,
    DownloadPodFileByWaybillService,
    DownloadPodFileService,
    GetBarCodeService,
    GetDetailByWaybillService,
    GetFleetInformationService, GetHoldAtTerminalService, GetManifestDetailsService,
    GetOperationFilesListService,
    GetOperationProofOfDeliveryBookingListService,
    GetPODDetailsService,
    GetPieceBarCodeService,
    GetPodByWaybillService, GetPodFileExceptionsReasonService, GetPodFilesService, GetQuotationByClientSubIdService, GetQuotationDetailByIdService, GetReWeightService, GetVolumetricByIdService, GetVolumetricService,
    ManifestUpdateService,
    NORDeliveryService,
    PushToOracleService,
    ReCalculateManifestService, SaveAdditionPickupBarcodeService, SaveFleetInformationService, SaveManifestService,
    SavePodDetailsService,
    SaveReWeightService,
    SearchOperationFilterService,
    UpdateBillTypeService,
    UpdateVolumetricDetailsByIdService,
    UploadBulkDeliveryService,
    UploadBulkPickUpService,
    UploadPodFileByWaybillService,
    UploadPodFilesService,
    assignDriverService, getAdhocDriversService, getDriverListService,
    getAdhocDriverListService,
    getOperationListService,
    getPodOperationListService,
    getScannedByListService,
    getIRSDriverListService,
    MultiUploadPodFileByWaybillService,
    GetValidAgreementDetailService,
    UpdateFodCodAmountService,
    UploadCostModuleFileService,
    PickupCancelRequestService,
    UploadAdditionalFileService,
    GetCustomerVolumetricService,
    ApproveVolumetricService,
    getAdhocTripsService,
} from '../services/operation-service';
import { getAonePodListService } from '../services/a-one-service';
import { FOUR_HUNDRED, TWO_HUNDRED_SUCCESS_CODE, calculateTotal, downloadBlob } from '../utils/app-common';
import { convertDateIntoMillis, convertMillisToDateMoment, monthsDate, ONE_MONTH, todayDate } from '../utils/luxon';
import { IReCalculateRequest, IReWeightRequest } from './../model/OperationModel';
import { AssignDeliveryService, InvoiceManifestService, OnRTOByIdService } from './../services/operation-service';
import { messageEnum, responseData, responseStatus } from "./common";
import { RcFile } from 'antd/lib/upload';

const initialState: InitialState = {
    operationList: [],
    driverList: [],
    pieceBarCodeList: [],
    volumetricList: [],
    volumetricListResponse: {},
    manifestationList: {},
    assignDriverResponse: {},
    reWeightObject: {},
    podList: {},
    reWeightResponse: undefined,
    fleetResponse: { fleetInformation: {}, manpowerInformation: {} },
    operationFiles: {
        pickupList: [],
        deliveryList: [],
        dataLoggerList: [],
        bookingFileList: [],
        manualPickupList: [],
        createBookingFileList: [],
        appointmentLetterList: [],
    },
    proofOfDeliveryDetailList: [],
    proofOfDeliveryFilesList: {
        id: 0,
        fileName: '',
        fileType: '',
        fileFormat: '',
        file: ''
    },
    uploadFileResponse: {},
    fileUploadResponse: undefined,
    volumetricResponse: undefined,
    fileExceptionsList: [],
    podDetails: {},
    updateManifestResponse: undefined,
    additionalPickUpResponse: undefined,
    uploadBulkPickUpResponse: undefined,
    uploadBulkDeliveryResponse: undefined,
    deliveryDateChangeResponse: undefined,
    deliveryDateDeleteStatus: undefined,
    deliveryDateDelete: {},
    rtoResponse: undefined,
    BarCodeList: {
        bookingBoxBarCodeList: [],
        id: 0,
        pickupType: '',
        waybillNo: ''
    },
    volumetricDetail: {
        id: 0,
        pickupId: 0,
        waybillNo: '',
        weight: 0,
        height: 0,
        length: 0,
        width: 0,
        itemCount: 0,
        volumetricWeight: 0
    },
    deliveryDateChange: {},
    norResponse: undefined,
    holdTerminalResponse: undefined,
    holdTerminal: [],
    quotations: [],
    selectedQuotation: {},
    refBookingDetail: {},
    bulkInvoice: {},
    bulkHoldManifest: {},
    failedDownloadedWaybills: undefined,
    podFilePreview: null,
    adhocDrivers: [],
    adhocDriverList: [],
    scannedByList: [],
    agreementDetail: {},
    fileUploadedResponse: undefined,
    customerVolumetricList: [],
    adhocTrips: [],

};

//** Get the current field vat value. Get the current field value */
const calculateVATCharges = ({ extraValue = 0, vatPercentage = 0 }: { extraValue?: number, vatPercentage?: number }) => ((vatPercentage / 100) * (extraValue)).toFixed(2);

const VAT_ENABLED = 'isVatEnabled',
    VAT_PERCENTAGE = 'vatPercentage',
    VAT_AMOUNT = 'vatAmount';
const fetchValue = ({ priceDetailList, key }: { priceDetailList: IQuotationPriceDetail[], key: string }) => {

    const originHandlingVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_HANDLING, filterKey: key }) : 0;
    const internationalFreightChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.INTERNATIONAL_FREIGHT_CHARGE, filterKey: key }) : 0;
    const borderAppointmentChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.BORDER_APPOINTMENT_CHARGES, filterKey: key }) : 0;
    const originBayanVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_BAYAN, filterKey: key }) : 0
    const miscellaneousVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.MISCELLANEOUS, filterKey: key }) : 0;
    const tollChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.TOLL_CHARGES, filterKey: key }) : 0
    const jafzaClearanceVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.JAFZA_CLEARANCE, filterKey: key }) : 0;
    const destinationClearanceVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_CLEARANCE_CHARGE, filterKey: key }) : 0;
    const destinationHandlingVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_HANDLING, filterKey: key }) : 0
    const transitCustomsDeclarationChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.TRANSIT_CUSTOMS_DECLARATION_CHARGE, filterKey: key }) : 0
    const labTestVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LAB_TEST, filterKey: key }) : 0
    const loadingOffLoadingVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOADING_OFFLOADING_CHARGES, filterKey: key }) : 0
    const quotationSealChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.SEAL_CHARGE, filterKey: key }) : 0
    const penaltyVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.PENALTY, filterKey: key }) : 0
    const documentationChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DOCUMENTATION_CHARGES, filterKey: key }) : 0;
    const localPickupVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOCAL_PICKUP, filterKey: key }) : 0;
    const localDeliveryVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOCAL_DELIVERY, filterKey: key }) : 0;
    const pickUpStorageVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.PICK_UP_STORAGE, filterKey: key }) : 0;
    const deliveryStorageVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DELIVERY_STORAGE, filterKey: key }) : 0;
    const additionalDeliveryChargesVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ADDITIONAL_DELIVERY_CHARGES, filterKey: key }) : 0;
    const causewayBridgeChargesVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.CAUSEWAY_BRIDGE_CHARGES, filterKey: key }) : 0
    const destinationBayanVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_BAYAN, filterKey: key }) : 0
    const detentionChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DETENTION_CHARGE, filterKey: key }) : 0
    const originClearanceVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_CLEARANCE_CHARGE, filterKey: key }) : 0
    const inspectionChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.INSPECTION_CHARGE, filterKey: key }) : 0;
    const gatePassChargeVatPercentage = priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.GATE_PASS_CHARGES, filterKey: key }) : 0
    return {
        originBayanVatPercentage,
        originHandlingVatPercentage,
        internationalFreightChargeVatPercentage,
        borderAppointmentChargeVatPercentage,
        miscellaneousVatPercentage,
        tollChargeVatPercentage,
        jafzaClearanceVatPercentage,
        destinationClearanceVatPercentage,
        destinationHandlingVatPercentage,
        transitCustomsDeclarationChargeVatPercentage,
        labTestVatPercentage,
        loadingOffLoadingVatPercentage,
        quotationSealChargeVatPercentage,
        penaltyVatPercentage,
        documentationChargeVatPercentage,
        localPickupVatPercentage,
        localDeliveryVatPercentage,
        pickUpStorageVatPercentage,
        deliveryStorageVatPercentage,
        additionalDeliveryChargesVatPercentage,
        causewayBridgeChargesVatPercentage,
        destinationBayanVatPercentage,
        detentionChargeVatPercentage,
        originClearanceVatPercentage,
        inspectionChargeVatPercentage,
        gatePassChargeVatPercentage
    }
}
//** This function is used to bind the manifestation data into an array to display the values in the International Charges
const quotationPriceList = ({ manifetDetail, manifestQuotationExtraCharges, priceDetailList = [] }: { manifetDetail: IManifestDetail, manifestQuotationExtraCharges: ManifestQuotationExtraCharges, priceDetailList: IQuotationPriceDetail[] }) => {
    const { internationalFreightCharge, originClearenceCharge, originHandling, originBayan, destinationClearenceCharge,
        destinationBayan, transitCustomsDeclarationCharge, gatePassCharges, inspectionCharges, labTest, loadingOffloadingCharges, destinationHandling,
        detentionCharge, sealCharge, penalty, documentationCharges, localPickup, localDelivery, pickupStorage,
        deliveryStorage, additionalDeliveryCharges,
        causewayBridgeCharges, jafzaClearence, tollCharges, borderAppointmentCharges, miscellaneous, customsDutyCharges } = manifetDetail as IManifestDetail || {};

    const {
        originHandlingCharges,
        destinationHandlingCharges,
        detentionCharge: detentionExtraCharge,
        labTest: labTestExtraCharge,
        loadingOffloadingCharge,
        penalty: penaltyExtraCharge,
        documentationCharges: documentationExtraCharges,
        sealCharge: sealExtraCharge,
        remarks,
        localPickup: localPickupExtraCharges,
        localDelivery: localDeliveryExtraCharges,
        pickupStorage: pickupStorageExtraCharges,
        deliveryStorage: deliveryStorageExtraCharges,
        additionalDeliveryCharges: additionalDeliveryExtraCharges,
        causewayBridgeCharges: causewayBridgeExtraCharges,
        borderAppointmentCharges: borderAppointmentExtraCharges,
        tollCharges: tollChargesExtraCharges,
        jafzaClearence: jafzaClearenceExtraCharges,
    } = manifestQuotationExtraCharges || {};

    const { borderAppointmentChargeVatPercentage, internationalFreightChargeVatPercentage, originBayanVatPercentage, originHandlingVatPercentage, miscellaneousVatPercentage,
        tollChargeVatPercentage, jafzaClearanceVatPercentage, destinationClearanceVatPercentage, destinationHandlingVatPercentage, transitCustomsDeclarationChargeVatPercentage,
        labTestVatPercentage, loadingOffLoadingVatPercentage, quotationSealChargeVatPercentage, penaltyVatPercentage, documentationChargeVatPercentage, localPickupVatPercentage,
        pickUpStorageVatPercentage, destinationBayanVatPercentage, detentionChargeVatPercentage,
        localDeliveryVatPercentage, deliveryStorageVatPercentage, additionalDeliveryChargesVatPercentage, causewayBridgeChargesVatPercentage,
        originClearanceVatPercentage, inspectionChargeVatPercentage, gatePassChargeVatPercentage
    } = fetchValue({ priceDetailList, key: VAT_PERCENTAGE });


    // ** Get the vat amount for manifest charges
    // ** Get the vat amount for extra charges
    // ** Add both the values and append in each field

    const list: IQuotationPriceDetailList[] = [{
        quotationHeadDescription: QUOTATION_LABEL.INTERNATIONAL_FREIGHT_CHARGE,
        name: QUOTATION_KEY.INTERNATIONAL_FREIGHT_CHARGE,
        totalAmount: internationalFreightCharge,
        manifestQuotationExtraCharges: 0,
        manifestQuotationVATExtraCharges: 0,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.INTERNATIONAL_FREIGHT_CHARGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: internationalFreightChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.INTERNATIONAL_FREIGHT_CHARGE, filterKey: VAT_AMOUNT }) : 0
    }, {
        quotationHeadDescription: QUOTATION_LABEL.ORIGIN_CLEARANCE_CHARGE,
        name: QUOTATION_KEY.ORIGIN_CLEARANCE_CHARGE,
        totalAmount: originClearenceCharge,
        manifestQuotationExtraCharges: 0,
        manifestQuotationVATExtraCharges: 0,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_CLEARANCE_CHARGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: originClearanceVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_CLEARANCE_CHARGE, filterKey: VAT_AMOUNT }) : 0
    }, {
        quotationHeadDescription: QUOTATION_LABEL.ORIGIN_HANDLING,
        name: QUOTATION_KEY.ORIGIN_HANDLING,
        totalAmount: originHandling,
        manifestQuotationExtraCharges: originHandlingCharges,
        remarks,
        manifestQuotationVATExtraCharges: originHandlingVatPercentage ? +calculateVATCharges({ extraValue: originHandlingVatPercentage, vatPercentage: +originHandlingVatPercentage }) : 0,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_HANDLING, filterKey: VAT_ENABLED }) : false,
        vatPercentage: originHandlingVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_HANDLING, filterKey: VAT_AMOUNT }) : 0
    }, {
        quotationHeadDescription: QUOTATION_LABEL.ORIGIN_BAYAN,
        name: QUOTATION_KEY.ORIGIN_BAYAN,
        manifestQuotationExtraCharges: 0,
        manifestQuotationVATExtraCharges: 0,
        totalAmount: originBayan,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_BAYAN, filterKey: VAT_ENABLED }) : false,
        vatPercentage: originBayanVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ORIGIN_BAYAN, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.DESTINATION_CLEARANCE_CHARGE,
        name: QUOTATION_KEY.DESTINATION_CLEARANCE_CHARGE,
        manifestQuotationExtraCharges: 0,
        manifestQuotationVATExtraCharges: 0,
        totalAmount: destinationClearenceCharge,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_CLEARANCE_CHARGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: destinationClearanceVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_CLEARANCE_CHARGE, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.DESTINATION_HANDLING,
        name: QUOTATION_KEY.DESTINATION_HANDLING,
        totalAmount: destinationHandling,
        manifestQuotationExtraCharges: destinationHandlingCharges,
        manifestQuotationVATExtraCharges: destinationHandlingVatPercentage ? +calculateVATCharges({ extraValue: destinationHandlingCharges, vatPercentage: +destinationHandlingVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_HANDLING, filterKey: VAT_ENABLED }) : false,
        vatPercentage: destinationHandlingVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_HANDLING, filterKey: VAT_AMOUNT }) : 0
    }, {
        quotationHeadDescription: QUOTATION_LABEL.DESTINATION_BAYAN,
        name: QUOTATION_KEY.DESTINATION_BAYAN,
        manifestQuotationExtraCharges: 0,
        manifestQuotationVATExtraCharges: 0,
        totalAmount: destinationBayan,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_BAYAN, filterKey: VAT_ENABLED }) : false,
        vatPercentage: destinationBayanVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DESTINATION_BAYAN, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.DETENTION_CHARGE,
        name: QUOTATION_KEY.DETENTION_CHARGE,
        totalAmount: detentionCharge,
        manifestQuotationExtraCharges: detentionExtraCharge,
        manifestQuotationVATExtraCharges: detentionChargeVatPercentage ? +calculateVATCharges({ extraValue: detentionExtraCharge, vatPercentage: +detentionChargeVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DETENTION_CHARGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: detentionChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DETENTION_CHARGE, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.TRANSIT_CUSTOMS_DECLARATION_CHARGE,
        name: QUOTATION_KEY.TRANSIT_CUSTOMS_DECLARATION_CHARGE,
        manifestQuotationExtraCharges: 0,
        manifestQuotationVATExtraCharges: 0,
        totalAmount: transitCustomsDeclarationCharge,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.TRANSIT_CUSTOMS_DECLARATION_CHARGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: transitCustomsDeclarationChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.TRANSIT_CUSTOMS_DECLARATION_CHARGE, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.INSPECTION_CHARGE,
        name: QUOTATION_KEY.INSPECTION_CHARGE,
        totalAmount: inspectionCharges,
        manifestQuotationExtraCharges: 0,
        manifestQuotationVATExtraCharges: 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.INSPECTION_CHARGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: inspectionChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.INSPECTION_CHARGE, filterKey: VAT_AMOUNT }) : 0
    }, {
        quotationHeadDescription: QUOTATION_LABEL.LAB_TEST,
        name: QUOTATION_KEY.LAB_TEST,
        totalAmount: labTest,
        manifestQuotationExtraCharges: labTestExtraCharge,
        manifestQuotationVATExtraCharges: labTestVatPercentage ? +calculateVATCharges({ extraValue: labTestExtraCharge, vatPercentage: labTestVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LAB_TEST, filterKey: VAT_ENABLED }) : false,
        vatPercentage: labTestVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LAB_TEST, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.LOADING_OFFLOADING_CHARGES,
        name: QUOTATION_KEY.LOADING_OFFLOADING_CHARGES,
        totalAmount: loadingOffloadingCharges,
        manifestQuotationExtraCharges: loadingOffloadingCharge,
        remarks,
        manifestQuotationVATExtraCharges: loadingOffLoadingVatPercentage ? +calculateVATCharges({ extraValue: loadingOffloadingCharge, vatPercentage: +loadingOffLoadingVatPercentage }) : 0,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOADING_OFFLOADING_CHARGES, filterKey: VAT_ENABLED }) : false,
        vatPercentage: loadingOffLoadingVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOADING_OFFLOADING_CHARGES, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.GATE_PASS_CHARGES,
        name: QUOTATION_KEY.GATE_PASS_CHARGES,
        manifestQuotationExtraCharges: 0,
        manifestQuotationVATExtraCharges: 0,
        totalAmount: gatePassCharges,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.GATE_PASS_CHARGES, filterKey: VAT_ENABLED }) : false,
        vatPercentage: gatePassChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.GATE_PASS_CHARGES, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.SEAL_CHARGE,
        name: QUOTATION_KEY.SEAL_CHARGE,
        totalAmount: sealCharge,
        manifestQuotationExtraCharges: sealExtraCharge,
        remarks,
        manifestQuotationVATExtraCharges: quotationSealChargeVatPercentage ? +calculateVATCharges({ extraValue: sealExtraCharge, vatPercentage: +quotationSealChargeVatPercentage }) : 0,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.SEAL_CHARGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: quotationSealChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.SEAL_CHARGE, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.PENALTY,
        name: QUOTATION_KEY.PENALTY,
        manifestQuotationExtraCharges: penaltyExtraCharge,
        totalAmount: penalty,
        manifestQuotationVATExtraCharges: penaltyVatPercentage ? +calculateVATCharges({ extraValue: penaltyExtraCharge, vatPercentage: +penaltyVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.PENALTY, filterKey: VAT_ENABLED }) : false,
        vatPercentage: penaltyVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.PENALTY, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.DOCUMENTATION_CHARGES,
        name: QUOTATION_KEY.DOCUMENTATION_CHARGES,
        totalAmount: documentationCharges,
        manifestQuotationExtraCharges: documentationExtraCharges,
        manifestQuotationVATExtraCharges: documentationChargeVatPercentage ? +calculateVATCharges({ extraValue: documentationExtraCharges, vatPercentage: +documentationChargeVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DOCUMENTATION_CHARGES, filterKey: VAT_ENABLED }) : false,
        vatPercentage: documentationChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DOCUMENTATION_CHARGES, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.LOCAL_PICKUP,
        name: QUOTATION_KEY.LOCAL_PICKUP,
        totalAmount: localPickup,
        manifestQuotationExtraCharges: localPickupExtraCharges,
        manifestQuotationVATExtraCharges: localPickupVatPercentage ? +calculateVATCharges({ extraValue: localPickupExtraCharges, vatPercentage: +localPickupVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOCAL_PICKUP, filterKey: VAT_ENABLED }) : false,
        vatPercentage: localPickupVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOCAL_PICKUP, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.LOCAL_DELIVERY,
        name: QUOTATION_KEY.LOCAL_DELIVERY,
        manifestQuotationVATExtraCharges: localDeliveryVatPercentage ? +calculateVATCharges({ extraValue: localDeliveryExtraCharges, vatPercentage: +localDeliveryVatPercentage }) : 0,
        totalAmount: localDelivery,
        manifestQuotationExtraCharges: localDeliveryExtraCharges,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOCAL_DELIVERY, filterKey: VAT_ENABLED }) : false,
        vatPercentage: localDeliveryVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.LOCAL_DELIVERY, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.PICK_UP_STORAGE,
        name: QUOTATION_KEY.PICK_UP_STORAGE,
        manifestQuotationVATExtraCharges: pickUpStorageVatPercentage ? +calculateVATCharges({ extraValue: pickupStorageExtraCharges, vatPercentage: +pickUpStorageVatPercentage }) : 0,
        totalAmount: pickupStorage,
        manifestQuotationExtraCharges: pickupStorageExtraCharges,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.PICK_UP_STORAGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: pickUpStorageVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.PICK_UP_STORAGE, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.DELIVERY_STORAGE,
        name: QUOTATION_KEY.DELIVERY_STORAGE,
        totalAmount: deliveryStorage,
        manifestQuotationExtraCharges: deliveryStorageExtraCharges,
        manifestQuotationVATExtraCharges: deliveryStorageVatPercentage ? +calculateVATCharges({ extraValue: deliveryStorageExtraCharges, vatPercentage: +deliveryStorageVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DELIVERY_STORAGE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: deliveryStorageVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.DELIVERY_STORAGE, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.ADDITIONAL_DELIVERY_CHARGES,
        name: QUOTATION_KEY.ADDITIONAL_DELIVERY_CHARGES,
        totalAmount: additionalDeliveryCharges,
        manifestQuotationExtraCharges: additionalDeliveryExtraCharges,
        manifestQuotationVATExtraCharges: additionalDeliveryChargesVatPercentage ? +calculateVATCharges({ extraValue: additionalDeliveryExtraCharges, vatPercentage: +additionalDeliveryChargesVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ADDITIONAL_DELIVERY_CHARGES, filterKey: VAT_ENABLED }) : false,
        vatPercentage: additionalDeliveryChargesVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.ADDITIONAL_DELIVERY_CHARGES, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.CAUSEWAY_BRIDGE_CHARGES,
        name: QUOTATION_KEY.CAUSEWAY_BRIDGE_CHARGES,
        totalAmount: causewayBridgeCharges,
        manifestQuotationExtraCharges: causewayBridgeExtraCharges,
        manifestQuotationVATExtraCharges: causewayBridgeChargesVatPercentage ? +calculateVATCharges({ extraValue: causewayBridgeExtraCharges, vatPercentage: +causewayBridgeChargesVatPercentage }) : causewayBridgeChargesVatPercentage,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.CAUSEWAY_BRIDGE_CHARGES, filterKey: VAT_ENABLED }) : false,
        vatPercentage: causewayBridgeChargesVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.CAUSEWAY_BRIDGE_CHARGES, filterKey: VAT_AMOUNT }) : 0
    }, {
        quotationHeadDescription: QUOTATION_LABEL.JAFZA_CLEARANCE,
        name: QUOTATION_KEY.JAFZA_CLEARANCE,
        totalAmount: jafzaClearence,
        manifestQuotationExtraCharges: jafzaClearenceExtraCharges,
        manifestQuotationVATExtraCharges: jafzaClearanceVatPercentage ? +calculateVATCharges({ extraValue: jafzaClearenceExtraCharges, vatPercentage: +jafzaClearanceVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.JAFZA_CLEARANCE, filterKey: VAT_ENABLED }) : false,
        vatPercentage: jafzaClearanceVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.JAFZA_CLEARANCE, filterKey: VAT_AMOUNT }) : 0
    }, {
        quotationHeadDescription: QUOTATION_LABEL.TOLL_CHARGES,
        name: QUOTATION_KEY.TOLL_CHARGES,
        totalAmount: tollCharges,
        manifestQuotationExtraCharges: tollChargesExtraCharges,
        manifestQuotationVATExtraCharges: tollChargeVatPercentage ? +calculateVATCharges({ extraValue: tollChargesExtraCharges, vatPercentage: +tollChargeVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.TOLL_CHARGES, filterKey: VAT_ENABLED }) : false,
        vatPercentage: tollChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.TOLL_CHARGES, filterKey: VAT_AMOUNT }) : 0

    }, {
        quotationHeadDescription: QUOTATION_LABEL.BORDER_APPOINTMENT_CHARGES,
        name: QUOTATION_KEY.BORDER_APPOINTMENT_CHARGES,
        totalAmount: borderAppointmentCharges,
        manifestQuotationExtraCharges: borderAppointmentExtraCharges,
        manifestQuotationVATExtraCharges: borderAppointmentChargeVatPercentage ? +calculateVATCharges({ extraValue: borderAppointmentExtraCharges, vatPercentage: +borderAppointmentChargeVatPercentage }) : 0,
        remarks,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.BORDER_APPOINTMENT_CHARGES, filterKey: VAT_ENABLED }) : false,
        vatPercentage: borderAppointmentChargeVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.BORDER_APPOINTMENT_CHARGES, filterKey: VAT_AMOUNT }) : 0

    },
    {
        quotationHeadDescription: QUOTATION_LABEL.CUSTOMS_DUTY_CHARGES,
        name: QUOTATION_KEY.CUSTOMS_DUTY,
        totalAmount: customsDutyCharges,
    },
    {
        quotationHeadDescription: QUOTATION_LABEL.MISCELLANEOUS,
        name: QUOTATION_KEY.MISCELLANEOUS,
        manifestQuotationVATExtraCharges: miscellaneousVatPercentage ? +calculateVATCharges({ extraValue: 0, vatPercentage: +miscellaneousVatPercentage }) : 0,
        totalAmount: miscellaneous,
        isVatEnabled: priceDetailList?.length ? !!findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.MISCELLANEOUS, filterKey: VAT_ENABLED }) : false,
        vatPercentage: miscellaneousVatPercentage,
        vatAmount: priceDetailList?.length ? +findValue({ quotationPriceDetailList: priceDetailList, key: QUOTATION_KEY.MISCELLANEOUS, filterKey: VAT_AMOUNT }) : 0

    }];
    return list;
}
const manifestDetail = (data) => {
    const { destinationOdaCityId, originOdaCityId, accountId, clientName, manifetDetail, manifestQuotationExtraCharges, priceDetailList } = data || {};
    return {
        ...data,
        destinationOdaCityId: destinationOdaCityId ?? undefined,
        originOdaCityId: originOdaCityId ?? undefined,
        accountId: `${accountId ?? undefined} - ${clientName ?? undefined}`,
        quotationPriceDetailList: [...quotationPriceList({ manifestQuotationExtraCharges, manifetDetail, priceDetailList })]
    };
}
const OperationStore = create<IOperationState>(((set, get) => ({
    ...initialState,
    GetOperationListAction: async (filteredData: IFilter) => {
        const payload: Partial<IFilter> = {
            ...filteredData,
            startDate: filteredData?.startDate ? filteredData?.startDate : convertDateIntoMillis(monthsDate(todayDate(), ONE_MONTH)),
            endDate: filteredData?.endDate ? filteredData?.endDate : convertDateIntoMillis(todayDate()),
        }
        const response = await getOperationListService(payload);
        const data = responseData(response?.data)
        const convertedResponse = data?.map((item: IOperation) => ({
            ...item,
            convertedDeliveryDate: convertMillisToDateMoment(data?.deliveryDate)
        }));
        set({ operationList: convertedResponse })
    },
    GetDriverListAction: async (isIRS = false) => {
        try {
            const response = await (isIRS ? getIRSDriverListService() : getDriverListService());
            if (response && response.data) {
                set({ driverList: responseData(response.data) });
            }
        } catch (error) {
            console.error('Error fetching driver list:', error);
        }
    },
    GetAdhocDriversAction: async () => {
        const response = await getAdhocDriversService();
        set({ adhocDrivers: responseData(response?.data) });
    },
    GetAdhocDriverListAction: async (unAssignDriver = false) => {
        const response = await getAdhocDriverListService(unAssignDriver);
        set({ adhocDriverList: responseData(response?.data) })
    },
    GetAdhocTripsAction: async (params) => {
        const response = await getAdhocTripsService(params);
        set({ adhocTrips: responseData(response?.data) || [] });
    },
    GetScannedByListListAction: async (req) => {
        const response = await getScannedByListService(req);
        set({ scannedByList: responseData(response?.data) })
    },
    AssignDriverAction: async (data: IDriverRequest) => {
        const response = await assignDriverService(data);
        set({ assignDriverResponse: responseData(response?.data) })
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.ASSIGNED_DRIVER_SUCCESSFULLY });
        }
    },
    AssignMultiDriverAction: async (data: IDriverRequest) => {
        const response = await assignDriverService(data, { silent: true });
        return response;
    },
    AssignDeliveryAction: async (data: IDriverRequest) => {
        const response = await AssignDeliveryService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.ASSIGNED_DELIVERY_DRIVER_SUCCESSFULLY });
        }
    },
    CancelOperationByIdAction: async (id: number) => {
        const response = await CancelBookingByIdService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.BOOKING_CANCELED });
        }
    },
    RTOByIdAction: async (id: string, filteredData: IFilter) => {
        const response = await OnRTOByIdService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ rtoResponse: response?.status })
            getNotificationStyle({ ...response, statusText: messageEnum.RTO_SUCCESSFUL });
            // trackPromise(get().GetOperationListAction(filteredData), 'operation-list-area');
        }
    },
    GetPieceBarCodeAction: async (id: number) => {
        const response = await GetPieceBarCodeService(id);
        set({ pieceBarCodeList: responseData(response?.data) });
    },
    GetVolumetricAction: async (id: number) => {
        const response = await GetVolumetricService(id);
        const data = responseData(response?.data);
        const { volumetricDetails, ...responseMetadata } = data ?? {};
        const convertedList = (volumetricDetails ?? []).map((item: IVolumetric) => ({
            ...item,
            pieceLevelTypeName: item?.pieceLevelType,
        }));
        set({ volumetricList: convertedList, volumetricListResponse: responseMetadata });
    },
    GetVolumetricDetailsByIdAction: async (id: number) => {
        const response = await GetVolumetricByIdService(id);
        set({ volumetricDetail: responseData(response?.data) });
    },
    UpdateVolumetricDetailsByIdAction: async (id: number, request: Pick<IVolumetric, 'weight' | 'height' | 'length' | 'width' | 'itemCount' | 'pieceLevelTypeId'>, paramId: number) => {
        const response = await UpdateVolumetricDetailsByIdService(id, request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ volumetricResponse: response?.status })
            getNotificationStyle({ ...response, statusText: messageEnum.RTO_SUCCESSFUL });
            trackPromise(get().GetVolumetricAction(paramId), 'manifest-list-area');
        }
    },
    CancelBookingByIdAction: async (id: number | undefined, filteredData: IFilter, request: { cancelReasonId: null, cancelRemarks?: undefined }) => {
        const response = await CancelBookingByIdService(id, request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            // trackPromise(get().GetOperationListAction(filteredData), 'operation-list-area');
        }
    },
    SearchFilterAction: async (filteredData: Partial<IFilter>) => {
        const response = await SearchOperationFilterService(filteredData);
        set({ operationList: responseData(response?.data) })
    },
    AssignPodAction: async (data: IPodResponse) => {
        const response = await AssignPodService(data);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: messageEnum.ASSIGNED_POD_SUCCESSFULLY });
        }
    },
    GetPodByWaybillAction: async (waybill?: string) => {
        const response = await GetPodByWaybillService(waybill);
        set({ podList: responseData(response?.data) });
        return response;
    },
    GetManifestDetailsAction: async (waybill: string | undefined) => {
        set({ manifestationList: {}, selectedQuotation: {} });
        const response = await GetManifestDetailsService(waybill);
        const data: IManifestationRequest = manifestDetail(responseData(response?.data));
        set({ manifestationList: data });
        if (data?.manifestQuote?.enquiryQuotationId) {
            set({ manifestationList: responseData(response?.data) });
            trackPromise(get().GetQuotationDetailByIdAction({ quotationId: data?.manifestQuote?.enquiryQuotationId }), 'quotation-area');
        };
    },
    UpdateBillTypeAction: async (request: IBillTypeUpdate, wayBillNumber?: string) => {
        const response = await UpdateBillTypeService(request, wayBillNumber);
        set({ BarCodeList: responseData(response?.data) });
        trackPromise(get().GetManifestDetailsAction(wayBillNumber), 'manifest-initial-area')
    },
    ClearOdaCityAction: async (request: IClearCity, wayBillNumber: string) => {
        const response = await ClearOdaCityService(request, wayBillNumber);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            trackPromise(get().GetManifestDetailsAction(wayBillNumber), 'manifest-initial-area')
        }
    },
    SaveAdditionPickupBarcodeAction: async (request: IPieceBarcodeRequest, id: number) => {
        const response = await SaveAdditionPickupBarcodeService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ additionalPickUpResponse: response?.status })
            getNotificationStyle(response);
            trackPromise(get().GetPieceBarCodeAction(id), 'piece-barcode-list-area')
        }
    },
    ReCalculateManifestAction: async ({ waybillNo, request }: { waybillNo?: string, request?: IReCalculateRequest }) => {
        set({ manifestationList: {}, selectedQuotation: {} });
        const response = await ReCalculateManifestService({ waybillNo, request });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: response?.data?.message });
            const data: IManifestationRequest = manifestDetail(responseData(response?.data));
            set({ manifestationList: data });
            if (data?.manifestQuote?.enquiryQuotationId) {
                trackPromise(get().GetQuotationDetailByIdAction({ quotationId: data?.manifestQuote?.enquiryQuotationId }), 'quotation-area');
            }
        }
    },
    GetQuotationDetailByIdAction: async ({ quotationId }: { quotationId?: number }) => {
        const response = await GetQuotationDetailByIdService({ quotationId })
        const merged = Object.assign(get().manifestationList, { priceDetailList: responseData(response?.data)?.quotationPriceDetailList });
        set({ manifestationList: manifestDetail(merged) });
    },
    InvoiceManifestAction: async (waybill?: string) => {
        const response = await InvoiceManifestService(waybill);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: response?.data?.message });
            trackPromise(get().GetManifestDetailsAction(waybill), 'manifest-initial-area')
        }
    },
    SaveManifestAction: async ({ waybillNo, request }: { waybillNo?: string, request?: Partial<IManifestationRequest> }) => {
        const response = await SaveManifestService({ waybillNo, request });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: response?.data?.message });
        }
    },
    GetReWeightAction: async (wayBillNumber: string) => {
        const response = await GetReWeightService(wayBillNumber);
        set({ reWeightObject: responseData(response?.data) })
    },
    SaveReWeightAction: async (body: IReWeightRequest, id: number) => {
        const response = await SaveReWeightService(body);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ reWeightResponse: response?.status });
            getNotificationStyle({ ...response, statusText: response?.data?.message });
        }
        get().GetVolumetricAction(id)
    },
    SaveFleetInformationAction: async (body: IFleetManPower) => {
        const response = await SaveFleetInformationService(body);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: response?.data?.message });
        }
    },
    GetFleetInformationAction: async (wayBillNumber: string) => {
        const response = await GetFleetInformationService(wayBillNumber);
        set({ fleetResponse: responseData(response?.data) });
    },
    GetOperationFilesListAction: async (wayBillNumber: string) => {
        const response = await GetOperationFilesListService(wayBillNumber);
        set({ operationFiles: responseData(response?.data) });
    },
    GetOperationProofOfDeliveryBookingListAction: async (wayBillNumber: string) => {
        const response = await GetOperationProofOfDeliveryBookingListService(wayBillNumber);
        set({ proofOfDeliveryDetailList: responseData(response?.data) });
    },
    SavePodDetailsAction: async (data: unknown, id: number, waybillNo: string, isOperation: boolean) => {
        const response = await SavePodDetailsService(data, id, isOperation);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: response?.data?.message! });
            trackPromise(get().GetOperationProofOfDeliveryBookingListAction(waybillNo), 'pod-booking-list-area')
        }
    },
    GetPodFilesAction: async (id: number) => {
        const response = await GetPodFilesService(id);
        set({ proofOfDeliveryFilesList: responseData(response?.data) });
    },
    UploadPodFileAction: async (id: number, fileObject: Partial<IFileUpload>, isOriginal: boolean) => {
        const response = await UploadPodFilesService(id, fileObject, isOriginal);
        set({ uploadFileResponse: responseStatus(response?.data) });
        getNotificationStyle({ ...response, statusText: responseData(response?.data?.message!) });
    },
    UploadPodFileByWaybillAction: async (waybill: string | undefined, fileObject: Partial<IFileUpload>, isOriginal: boolean) => {
        const response = await UploadPodFileByWaybillService(waybill, fileObject, isOriginal);
        set({ uploadFileResponse: responseStatus(response?.data) });
        getNotificationStyle({ ...response, statusText: responseData(response?.data?.message!) });
    },
    DownloadPodFileAction: async (id: number) => {
        const response = await DownloadPodFileService(id);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileType: fileName, fileFormat, file } = responseData(response?.data);
            trackPromise(downloadBlob(file, fileName, fileFormat), 'download-pod-file-area');
        }
    },
    DownloadPodFileByWaybillAction: async (waybill: string) => {
        const response = await DownloadPodFileByWaybillService(waybill);
        if (response?.status === FOUR_HUNDRED) {
            set({ failedDownloadedWaybills: waybill });
            return false;
        }
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileType: fileName, fileFormat, file } = responseData(response?.data);
            trackPromise(downloadBlob(file, waybill, fileFormat), 'download-pod-file-area');
            return true;
        }
        return false;
    },
    GetPodFileExceptionsReasonAction: async () => {
        const response = await GetPodFileExceptionsReasonService();
        set({ fileExceptionsList: responseData(response?.data) })
    },
    GetPODDetailsAction: async (airwayBillNumber?: string) => {
        const response = await GetPODDetailsService(airwayBillNumber);
        set({ podDetails: responseData(response?.data) })
    },
    UpdateManifestAction: async (waybillNumber?: string, request?: Partial<IUpdateManifest>) => {
        const response = await ManifestUpdateService(waybillNumber, request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: response?.data?.message });
            set({ updateManifestResponse: response?.status })
            await trackPromise(get().GetManifestDetailsAction(waybillNumber), 'manifest-initial-area')
        }
        return response;
    },
    UploadFileAction: async (fileObject: IFileUploads, waybillNo: string) => {
        const response = await UploadFileService(fileObject);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ fileUploadResponse: response?.status });
            getNotificationStyle({ ...response, statusText: responseData(response?.data?.message!) });
            trackPromise(get().GetOperationFilesListAction(waybillNo), 'files-list-area')
        }
    },
    GetBarCodeAction: async (wayBill: string) => {
        const response = await GetBarCodeService(wayBill);
        set({ BarCodeList: responseData(response?.data) });
    },
    DownloadBulkDeliveryAction: async () => {
        const response = await DownloadBulkDeliveryService();
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileType, fileName, file } = responseData(response?.data);
            downloadBlob(file, fileName, fileType);
        }
    },
    DownloadBulkPickUpAction: async () => {
        const response = await DownloadBulkPickUpService();
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileType, file, fileName } = responseData(response?.data);
            downloadBlob(file, fileName, fileType);
        }
    },
    UploadBulkPickUpAction: async (request: Partial<IFileUpload>, isBulkPickUp: boolean) => {
        const response = await UploadBulkPickUpService(request, isBulkPickUp);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ uploadBulkPickUpResponse: response?.status });
        }
    },
    UploadBulkDeliveryAction: async (request: Partial<IFileUpload>, isBulkDelivery: boolean) => {
        const response = await UploadBulkDeliveryService(request, isBulkDelivery);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ uploadBulkDeliveryResponse: response?.status });
        }
    },
    ChangeDeliveryDateAction: async (request: IChangeDeliveryDate) => {
        const response = await ChangeDeliveryDateService(request);
        const { statusCode } = (response?.data) || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({
                deliveryDateChangeResponse: statusCode,
                deliveryDateChange: responseData(response?.data)
            })
        }
        getNotificationStyle(response);
    },
    DeleteDeliveryDateAction: async (payload) => {
        const response = await DeleteDeliveryDateService(payload);
        const { statusCode } = (response?.data) || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({
                deliveryDateDeleteStatus: statusCode,
                deliveryDateDelete: responseData(response?.data)
            })
        }
        return response;
    },
    GetPodOperationListAction: async (filteredData: IFilter) => {
        const response = await getPodOperationListService(filteredData);
        const data = responseData(response?.data)
        const convertedResponse = data?.map((item: IOperation) => ({
            ...item,
            convertedDeliveryDate: convertMillisToDateMoment(data?.deliveryDate)
        }));
        set({ operationList: convertedResponse })
    },
    GetAonePodListAction: async (filteredData: IFilter) => {
        const response = await getAonePodListService(filteredData);
        const data = responseData(response?.data)
        const convertedResponse = data?.map((item: IOperation) => ({
            ...item,
            convertedDeliveryDate: convertMillisToDateMoment(data?.deliveryDate)
        }));
        set({ operationList: convertedResponse })
    },
    NORDeliveryAction: async (request: Partial<INorDelivery>) => {
        const response = await NORDeliveryService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ norResponse: response?.status });
            trackPromise(get().GetManifestDetailsAction(request?.waybillNo), 'manifest-initial-area')
            getNotificationStyle(response);
        }
    },
    PushToOracleAction: async (wayBillNo: string | undefined) => {
        const response = await PushToOracleService(wayBillNo);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            trackPromise(get().GetManifestDetailsAction(wayBillNo), 'manifest-initial-area')
        }
    },
    GetHoldAtTerminalAction: async (wayBillNo: string | undefined) => {
        const response = await GetHoldAtTerminalService(wayBillNo);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ holdTerminal: responseData(response?.data) });
        }
    },
    AddHoldAtTerminalAction: async (request: IAddHoldAtTerminalRequest) => {
        const response = await AddHoldAtTerminalService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ holdTerminalResponse: response?.status })
            trackPromise(get().GetHoldAtTerminalAction(request?.waybillNo), 'hold-terminal-area');
        }
    },
    GetQuotationByClientSubIdAction: async ({ clientSubId, productId }: { clientSubId?: number, productId?: number }) => {
        const response = await GetQuotationByClientSubIdService({ clientSubId, productId });
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ quotations: responseData(response?.data) })
        }
    },
    SelectedQuotationAction: (id?: number) => {
        set({ selectedQuotation: {} });
        const selectedQuotation: Partial<IQuotation> = get().quotations?.find((quotation: IQuotation) => quotation?.id === id) ?? {};
        const quotation = Object.assign(selectedQuotation,
            {
                ...get().manifestationList,
                manifestQuote: {
                    enquiryQuotationId: selectedQuotation?.id,
                    enquiryId: selectedQuotation?.id,
                    quotationNumber: selectedQuotation?.quotationNumber,
                },
                manifetDetail: Object.assign({ ...get().manifestationList?.manifetDetail }, {
                    internationalVatAmount: calculateTotal({ list: selectedQuotation?.quotationPriceDetailList, key: 'vatAmount' })
                }),
                quotationPriceDetailList: selectedQuotation?.quotationPriceDetailList?.map((item) => ({
                    ...item,
                    vatPercentage: item?.vatId ? item?.vatPercentage : 0,
                    totalAmount: item?.selling
                })),
            });
        set({
            manifestationList: quotation,
            selectedQuotation: quotation
        })
    },
    GetDetailByWaybillAction: async (refNumber?: string) => {
        const response = await GetDetailByWaybillService(refNumber);
        set({ refBookingDetail: responseData(response?.data) })
    },
    BulkInvoiceAction: async (request?: IBulkInvoiceRequest) => {
        set({ bulkInvoice: {} })
        const response = await BulkInvoiceService(request);
        // getNotificationStyle(response);
        set({ bulkInvoice: responseData(response?.data) });
        return response;
    },
    BulkHoldManifestAction: async (request?: IBulkHoldManifestRequest) => {
        set({ bulkHoldManifest: {} })
        const response = await BulkHoldManifestService(request);
        set({ bulkHoldManifest: responseData(response?.data) });
        return response;
    },
    MultiUploadPodFileByWaybillAction: async (fileObject: RcFile, isOriginal: boolean) => {
        const response = await MultiUploadPodFileByWaybillService(fileObject, isOriginal);
        return response;
    },
    GetValidAgreementDetailAction: async (request: IValidAgreementDetailRequest) => {
        const response = await trackPromise(GetValidAgreementDetailService(request), 'valid-agreement-detail-area');;
        set({ agreementDetail: responseData(response?.data) || {} });
    },
    UpdateFodCodAmountAction: async (request: IUpdateCodRequest) => {
        const response = await trackPromise(UpdateFodCodAmountService(request), 'valid-agreement-detail-area');
        getNotificationStyle(response);
        return response;
    },
    UploadCostModuleFilesAction: async (request: FileUploadRequest) => {
        const response = await trackPromise(UploadCostModuleFileService(request), 'upload-cost-module-file-area');
        getNotificationStyle(response);
        return response;
    },
    PickUpCancelRequestAction: async (request) => {
        const response = await trackPromise(PickupCancelRequestService(request), 'pickup-cancel-request-area');
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        }
        return response;
    },
    UploadAdditionalFileAction: async (waybill: string | undefined, fileObject: Partial<IFileUpload>) => {
        const response = await UploadAdditionalFileService(waybill, fileObject);
        const { statusCode } = response?.data || {};
        set({ uploadFileResponse: responseStatus(response?.data) });
        set({ fileUploadedResponse: statusCode });
        getNotificationStyle({ ...response, statusText: responseData(response?.data?.message!) });
    },
    GetCustomerVolumetricAction: async (waybillNo) => {
        const response = await GetCustomerVolumetricService(waybillNo);
        set({ customerVolumetricList: responseData(response?.data) || [] });
    },
    ApproveVolumetricAction: async (bookingId: number, waybillNo: string, remarks: string) => {
        const response = await ApproveVolumetricService(waybillNo, remarks);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle({ ...response, statusText: response?.data?.message });
            trackPromise(get().GetVolumetricAction(bookingId), 'manifest-list-area');
        }
    },
    ClearFailedWaybillsAction: () => set({ failedDownloadedWaybills: undefined }),
    GetPodFileByWaybillAction: async (waybill: string) => {
        const response = await DownloadPodFileByWaybillService(waybill);
        if (response?.status === FOUR_HUNDRED) {
            set({ podFilePreview: { found: false, file: '', fileFormat: '', waybillNo: waybill, fileName: '' } });
        }
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            const { fileName, fileFormat, file } = responseData(response?.data);
            set({ podFilePreview: { found: true, file, fileFormat, waybillNo: waybill, fileName: fileName ?? waybill } });
        }
    },
    ClearPodFilePreviewAction: () => set({ podFilePreview: null }),
    ClearOperationStoreAction: () => set(initialState)
})))

export const useOperationStore = (OperationStore)
